// USA
export const locale = {
  TRANSLATOR: {
    HOME: "Home",
    LINES: "Production lines",
    LINE: "Production line",
    LINEID: "Production line ID",
    OVERVIEWLINE: "Production line overview",
    LASTCHECK: "Last check",
    LAST_INSPECTED: "Last inspection",
    VIEW_ALL: "View all",
    CLEAR: "Clear",
    EDIT: "Edit",
    SAVE: "Save",
    JUST_CHANGED: "All good",
    BE_CAREFULL: "Be carefull",
    MUST_CHANGE: "Must change",
    CHANGE_STATUS_FOR_ENTIRE: "Change status for entire",
    NOW_ITS: "now it's",
    UNCHANGED: "unchanged",
    SEARCH: "Search...",
    GETQUOTE: "Get quote",
    HIDEQUOTE: "Hide quote",
    GETQUOTETOOLTIP: "Receive quote to replace used spare parts",
    INSPECT_BUTTON: "Inspect button",
    STATUS: "Status",
    AMOUNT: "Amount",
    TOTAL_LENGTH: "Total length (mm)",
    NOTES: "Notes",
    STOCK_LOCATION: "Stock location",
    TRACKS: "Tracks",
    SERIES: "Series",
    WIDTH: "Width",
    HIGH: "High",
    DIAMETER: "Diameter",
    OUTSIDE_DIAMETER: "Outside diameter",
    COLOR: "Color",
    RED: "Red",
    ORANGE: "Orange",
    GREEN: "Green",
    TOTAL: "Total",
    LENGTH: "Length",
    CONVEYOR: "Conveyor",
    SECTION: "Section",
    NAME: "Name",
    NUMBEROFTRACKS: "number of tracks",
    CATEGORIES: "Categories",
    ADD_EXTRA_NOTE_HERE: "Add extra note here...",
    CHOOSEFILEDROP: "Choose a file or drop it here...",
    OPEN: "Open",
    OPEN_PDF: "Open .pdf",
    MORE_PDF: "Zoom, rotate & download PDF",
    UPLOAD_PDF: "Upload .pdf",
    UPLOAD: "Upload",
    MAINTENANCE_HISTORY: "Maintenance history",
    MAINTENANCE: "Maintenance log",
    TERMSANDCONDITIONS: "Terms and Conditions",
    TERMSANDCONDITIONS_URL: "https://app.max-lineconnected.com/media/Algemene%20voorwaarden%20241218%20v1%20Max-Line%20Maintenance%20and%20Trading%20BV-EN.pdf",
    TECHNICALPARTS: "Technical parts",
    SEEDETAILS: "See details",
    PREV: "Previous",
    NEXT: "Next",
    SELECT: "Select your language"
  },
  PARTS: {
    PARTS: "Parts",
    Motor: "Motor",
    DriveBearing: "Bearing(s)",
    IdlerBearing: "Idler Bearing",
    ChainBelt: "Chain & Belt",
    DriveSprocket: "Sprocket(s)",
    IdlerSprocket: "Idler Sprocket",
    Curve: "Curve",
    Wearstrip: "Wearstrip",
    Roller: "Roller",
    Components: "Components"
  },
  FORM: {
    TO: "To",
    FROM: "From",
    SUBJECT: "Subject",
    SELECT_PARTS: "Select parts",
    MESSAGE: "Message"
  },
  MENU: {
    NEW: "new",
    ACTIONS: "Actions",
    CREATE_POST: "Create New Post",
    PAGES: "Pages",
    FEATURES: "Features",
    APPS: "Apps",
    DASHBOARD: "Dashboard"
  },
  AUTH: {
    GENERAL: {
      OR: "Or",
      SUBMIT_BUTTON: "Submit",
      NO_ACCOUNT: "Don't have an account?",
      SIGNUP_BUTTON: "Sign Up",
      FORGOT_BUTTON: "Forgot Password",
      BACK_BUTTON: "Back",
      PRIVACY: "Privacy",
      LEGAL: "Legal",
      CONTACT: "Contact"
    },
    LOGIN: {
      TITLE: "Login Account",
      BUTTON: "Sign In"
    },
    FORGOT: {
      TITLE: "Forgot Password?",
      DESC: "Enter your email to reset your password",
      SUCCESS: "Your account has been successfully reset."
    },
    REGISTER: {
      TITLE: "Sign Up",
      DESC: "Enter your details to create your account",
      SUCCESS: "Your account has been successfuly registered."
    },
    INPUT: {
      EMAIL: "Email",
      FULLNAME: "Fullname",
      PASSWORD: "Password",
      CONFIRM_PASSWORD: "Confirm Password",
      USERNAME: "Username"
    },
    VALIDATION: {
      INVALID: "{{name}} is not valid",
      REQUIRED: "{{name}} is required",
      MIN_LENGTH: "{{name}} minimum length is {{min}}",
      AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
      NOT_FOUND: "The requested {{name}} is not found",
      INVALID_LOGIN: "The login detail is incorrect",
      REQUIRED_FIELD: "Required field",
      MIN_LENGTH_FIELD: "Minimum field length:",
      MAX_LENGTH_FIELD: "Maximum field length:",
      INVALID_FIELD: "Field is not valid"
    }
  },
  ECOMMERCE: {
      SHOP: "Shop",
      CATALOG: "Your catalog",
      SHOP_NOW: "shop now",
      WELCOME: "Welcome",
      ADDTOCART: "Add to cart",
      VIEW_PRODUCT: "View product",
      VIEW: "View",
      VIEW_ALL: "View all",
      MINIMUM_QUANTITIY: "Minimum quantity to buy",
      PRICE: "Price",
      PRODUCT_ADDED: "Product added to cart",
      ORDER: "Order",
      ORDERS: "Orders",
      ORDERS_STATUS: "Orders status",
      CART: "Cart",
      USER: "User",
      TOTAL_PRICE: "Total price",
      ORDER_OVERVIEW: "Order overview",
      CART_OVERVIEW: "Your cart",
      DATE: "Date",
      IN_PROGRESS: "In progress",
      APPROVED: "Approved",
      COMPLETED: "Completed",
      CANCELED: "Canceled",
      OPEN_ORDER_DETAILS: "Open order details #",
      PRODUCTS: "Products",
      QTY: "Qty",
      SU: "SU",
      DELETE: "Delete",
      PU: "PU",
      TOTAL: "Totaal",
      SUBTOTAL: "Subtotaal",
      TOTAL_EX_VAT: "Totaal EX BTW",
      CHECKOUT: "Checkout",
      YOUR_NOTE: "Your note",
	  ADD_ORDER_NOTE: "Add an order note here...",
	  PLACE_ORDER_NOW: "Place order now",
	  EX_VAT_DELIVERY_MSG: "Excludes VAT and delivery if applicable",
	  MY_CART: "My cart",
	  CART_IS_EMPTY: "Cart is empty",
	  PRODUCT_ADDED_TO_CART: "Product added to cart",
	  REFRESH: "Refresh",
	  CLOSE: "Close",
	  PRINT_PDF: "Print PDF",
	  NO_ORDERS_FOUND_PLACE_FIRST_ORDER: "No orders were found, place your first order",
    COMMON: {
      SELECTED_RECORDS_COUNT: "Selected records count: ",
      ALL: "All",
      SUSPENDED: "Suspended",
      ACTIVE: "Active",
      FILTER: "Filter",
      BY_STATUS: "by Status",
      BY_TYPE: "by Type",
      BUSINESS: "Business",
      INDIVIDUAL: "Individual",
      SEARCH: "Search",
      IN_ALL_FIELDS: "in all fields"
    },
    CUSTOMERS: {
      CUSTOMERS: "Customers",
      CUSTOMERS_LIST: "Customers list",
      NEW_CUSTOMER: "New Customer",
      DELETE_CUSTOMER_SIMPLE: {
        TITLE: "Customer Delete",
        DESCRIPTION: "Are you sure to permanently delete this customer?",
        WAIT_DESCRIPTION: "Customer is deleting...",
        MESSAGE: "Customer has been deleted"
      },
      DELETE_CUSTOMER_MULTY: {
        TITLE: "Customers Delete",
        DESCRIPTION: "Are you sure to permanently delete selected customers?",
        WAIT_DESCRIPTION: "Customers are deleting...",
        MESSAGE: "Selected customers have been deleted"
      },
      UPDATE_STATUS: {
        TITLE: "Status has been updated for selected customers",
        MESSAGE: "Selected customers status have successfully been updated"
      },
      EDIT: {
        UPDATE_MESSAGE: "Customer has been updated",
        ADD_MESSAGE: "Customer has been created"
      }
    }
  }
};
